import { useEffect, useState } from "react";
import {
  getSmsSettings,
  rehydrateSmsSettings,
  resetSmsSettings,
  subscribeSmsSettings,
  updateSmsSettings,
} from "../lib/smsSettingsStore";

export function useSmsSettings() {
  const [settings, setSettings] = useState(getSmsSettings());

  useEffect(() => {
    void rehydrateSmsSettings();

    const unsubscribe = subscribeSmsSettings(() => {
      setSettings(getSmsSettings());
    });

    setSettings(getSmsSettings());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    settings,
    updateSmsSettings,
    resetSmsSettings,
  };
}